import axios from "@/api/axiosInstance";
import { CreateTeamRequest, CreateTeamResponse } from "./types";

export const createTeam = async (
  requestData: CreateTeamRequest,
): Promise<CreateTeamResponse> => {
  const response = await axios.post<CreateTeamResponse>(
    "/api/private/employee-directory/teams",
    requestData,
  );
  return response.data;
};
